import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useSubscription } from "../contexts/SubscriptionContext";

export default function ProtectedRoute({ children, requireSubscription = true }) {
    const { isAuthenticated, loading: authLoading } = useAuth();
    const { hasActiveSubscription, loading: subLoading, error: subError } = useSubscription();
    const location = useLocation();

    if (authLoading || subLoading) {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh"
            }}>
                <p>Loading...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If subscription check failed due to error, fail closed
    if (subError) {
        console.error("Subscription check failed:", subError);
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                color: "#9ca3af",
                gap: "1rem",
            }}>
                <p>Unable to verify your subscription. Please try again.</p>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        padding: "0.5rem 1rem",
                        background: "#1f2937",
                        color: "#fff",
                        border: "1px solid #374151",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                    }}
                >
                    Retry
                </button>
            </div>
        );
    }

    // Check subscription if required
    if (requireSubscription && !hasActiveSubscription) {
        return <Navigate to="/subscribe" replace />;
    }

    return children;
}